import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { setTime, wait } from 'Src/me/pages/guest/proposals/new/utils';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
// import { sendGa4Event } from '@/common/lp/exterior_outer-wall/typescript/utils';
import type { FeaturePropsType } from '../../../../../chat/views/types';
import { RenderCityModalPropsType } from '../../../../../chat/views/CityModal/index';
import { useModalView } from '../../../../hooks/useModalView';

const { tablet, mobile } = mediaQueries();

export type CityModalPropsType = FeaturePropsType<RenderCityModalPropsType>

export const CityModal = (props: CityModalPropsType) => {
  const {
    answerHandler,
    isInstant = false,
    continueHandler,
    citiesGroupedByKana,
  } = props;
  const {
    openModalHandler,
    closeModalHandler,
    removeDisableEscKeyEvent,
    Modal,
  } = useModalView({ keyName: 'city', isDisableOverlay: true, isDisableEscKey: true });

  const onClickHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
    const { textContent } = event.currentTarget;

    // ボタンのクリックイベントを実行
    answerHandler(event);

    // モーダルを閉じる
    closeModalHandler();

    // Escキーを無効化を解除
    removeDisableEscKeyEvent();

    // 回答内容を渡して次の処理に進む
    continueHandler({
      value: textContent,
      answerText: textContent,
      selfDomReferences: [],
    });
  };

  React.useEffect(() => {
    // モーダルを開く
    openModalHandler();
  }, [openModalHandler]);

  return (
    <Modal>
      <div
        css={css`
          min-width: 380px;
          max-height: 600px;
          display: flex;
          flex-direction: column;
          background-color: #fff;
          border: 2px solid #041156;
          border-radius: 10px;

          ${tablet(() => css`
            width: calc(100dvw - 4em);
            max-width: 450px;
            height: 80dvh;
            max-height: 700px;
          `)}

          ${mobile(() => css`
            max-width: none;
            min-width: 300px;
            max-height: none;
          `)}
        `}
      >
        <p
          css={css`
            color: #fff;
            font-size: 17px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 46px;
            min-height: 46px;
            background-color: #041156;
            border-radius: 6px 6px 0 0;
          `}
        >
          市区町村
        </p>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 24px 0;
            padding: 1.5em 1em;
            overflow-y: scroll;
            flex: 1;

            ${mobile(({ clamp }) => css`
              padding: 1.5em ${clamp('0.7em', '1em')};
            `)}
          `}
        >
          {citiesGroupedByKana.map(({ kana, cities }) => {
            return (
              <div key={kana}>
                <div
                  css={css`
                    width: fit-content;
                    margin-bottom: 8px;
                    padding-left: 3px;
                  `}
                >
                  <p
                    css={css`
                      color: #fff;
                      font-size: 18px;
                      font-weight: bold;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 30px;
                      height: 30px;
                      background-color: #041156;
                      border-radius: 50%;

                      ${mobile(({ clamp }) => css`
                        font-size: ${clamp('16px', '18px')};
                      `)}
                    `}
                  >
                    {kana}
                  </p>
                </div>
                <ul>
                  {cities.map(({ id, name }) => {
                    return (
                      <li
                        key={id}
                        css={css`
                          border-bottom: 1px solid #ccc;
                        `}
                      >
                        <button
                          type='button'
                          id={`ga_event_city_${id}`}
                          onClick={onClickHandler}
                          value={id}
                          css={css`
                            color: #7c7a78;
                            font-size: 20px;
                            font-weight: bold;
                            width: 100%;
                            padding: 12px 14px;

                            ${mobile(({ clamp }) => css`
                              font-size: ${clamp('18px', '20px')};
                            `)}

                            &:hover {
                              color: #7c7a78;
                              background-color: #fff7c9;
                            }
                          `}
                        >
                          {name}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};
